import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { SpiralCinematic } from "@/components/SpiralCinematic";
import { CocoonMark } from "@/components/CocoonMark";

export function SplashScreen() {
  const [visible, setVisible] = useState(() => {
    if (typeof window === "undefined") return false;
    // Never block the login page, and only show once per browser session.
    if (window.location.pathname.startsWith("/entrer")) return false;
    return !sessionStorage.getItem("cocoon_splash_seen");
  });

  useEffect(() => {
    if (!visible) return;
    try { sessionStorage.setItem("cocoon_splash_seen", "1"); } catch (e) {}
    const timer = setTimeout(() => setVisible(false), 3000);
    return () => clearTimeout(timer);
  }, [visible]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          key="splash"
          data-testid="splash-screen"
          className="fixed inset-0 z-[100] starfield flex flex-col items-center justify-center"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, scale: 1.04 }}
          transition={{ duration: 0.7, ease: "easeInOut" }}
        >
          <motion.img
            src="/cocoon-logo-glow.png"
            alt="COCOON MIND"
            data-testid="splash-logo"
            className="w-auto select-none"
            style={{ height: "clamp(220px, 46vw, 380px)", filter: "drop-shadow(0 0 34px hsl(28 96% 56% / 0.45))" }}
            initial={{ opacity: 0, scale: 0.82, y: 8 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 1.1, ease: "easeOut" }}
          />
          <motion.span
            className="font-display tracking-tight mt-2"
            style={{ fontSize: "clamp(2rem, 7vw, 3.75rem)" }}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.9 }}
          >
            <CocoonMark letterClassName="cocoon-hero" withMind />
          </motion.span>
          <motion.span
            className="text-primary/70 tracking-[0.3em] uppercase text-xs mt-3"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 1.4 }}
          >
            apprentissage continu
          </motion.span>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
